function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.047 4.1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M21,20h-.6V3.319l.195.09a.95.95,0,0,0,.81-1.72L9.359-4.01a.967.967,0,0,0-.815,0L-3.5,1.719a.949.949,0,0,0-.45,1.265.952.952,0,0,0,.86.54.939.939,0,0,0,.4-.09l.19-.09V20h-.595a.949.949,0,0,0-.95.95.949.949,0,0,0,.95.95H21A.95.95,0,1,0,21,20Zm-5.5-3.949V20H2.4V16.052Zm0-3v1.1H2.4v-1.1Zm0-3v1.1H2.4v-1.1Zm.95-1.9h-15A.949.949,0,0,0,.5,9.1V20h-1.1V2.444L8.954-2.1,18.5,2.419V20H17.4V9.1A.949.949,0,0,0,16.453,8.153Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M-33.419,130.72a.071.071,0,0,0,.071-.071c0-.02,0-.02-.011-.031a3.093,3.093,0,0,0-2.494-1.417,2.031,2.031,0,0,0-1.749,1.169c-.04.063-.094.134-.123.186-.683.02-5.7.031-6.423.011-.031-.051-.063-.1-.1-.166a1.968,1.968,0,0,0-1.737-1.18,3.033,3.033,0,0,0-2.472,1.4.08.08,0,0,0,.02.1.05.05,0,0,0,.031.011l1.84.02v1.923h-1.86a.071.071,0,0,0-.071.071c0,.02,0,.02.011.031a3.07,3.07,0,0,0,.4.506,3.024,3.024,0,0,0,2.1.9,2.031,2.031,0,0,0,1.749-1.169c.04-.063.094-.134.123-.186.683-.02,5.7-.031,6.423-.011l.1.166a1.961,1.961,0,0,0,1.729,1.189,3.078,3.078,0,0,0,2.472-1.4.069.069,0,0,0,.011-.071c-.02-.02-.04-.04-.063-.04l-1.84-.02V130.72Z",
  transform: "translate(49.877 -127.246)"
}));

var SvgCarService = function SvgCarService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26.001,
    viewBox: "0 0 26 26.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarService, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car-service.39c6ec60.svg";
export { ForwardRef as ReactComponent };